module.exports = __webpack_public_path__ + "sunsemweb/img/pbanner.46fc90f6.png";